import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../Button';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
const MatureAgeBlockedOverlay = (_param)=>{
    var { deviation , overrideMatureFilter  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "overrideMatureFilter"
    ]);
    const { t  } = useTranslation();
    const sfwbrowse = useFlag('sfwbrowse');
    if (sfwbrowse) {
        return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
            deviation: deviation,
            icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
                size: IconSize.HUGE
            }),
            text: t('deviationview.blocked.mature.text.sfwbrowse')
        }, props));
    }
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature.underage'),
        text: props.compact ? null : t('deviationview.blocked.mature.underage.text'),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: props.compact ? 'small' : 'medium',
            onClick: overrideMatureFilter
        }, t('deviationview.blocked.displayAnyway'))
    }, props));
};
MatureAgeBlockedOverlay.displayName = 'MatureAgeBlockedOverlay';
export default MatureAgeBlockedOverlay;
